export enum ProfileActionsType {
  SAVE_USER = 'SAVE_USER',
}
